import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20gradient%20background%20with%20soft%20cream%20and%20golden%20accents%2C%20minimalist%20luxury%20aesthetic%2C%20smooth%20flowing%20textures%2C%20professional%20corporate%20atmosphere%2C%20subtle%20geometric%20elements%2C%20warm%20inviting%20tone&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
            准备好开启您的高品质之旅了吗？
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-200">
            立即注册hth，享受正品保障、极速响应与专属会员权益
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/membership"
              className="whitespace-nowrap inline-flex items-center px-8 py-3 text-sm md:text-base font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
            >
              立即注册
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center px-8 py-3 text-sm md:text-base font-medium rounded-md border border-background-300/60 text-background-50 hover:bg-background-50/10 transition-all cursor-pointer"
            >
              联系客服
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}